/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import { PaymentReceiveGraph } from './PaymentReceiveGraph'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { ListViewProvider } from '../core/ListViewProvider'
import { CardsWidget, CardsWidgetUser, ListsWidget, ListsWidgetRequest } from './ListsWidget'
import { MixedWidget } from './MixedWidget'
import { getBuyerProductsWithCount, getSellerProductsWithCount, getUserCountStateWise, PlanActiveUserCount, getUserTypeCount, getCurrentMonthCount, PlanSubscriberCount, getTopStats } from './_requests'
import "./dashboard.css"
const DashboardContent: FC = () => {
  const [sellerProductCount, setSellerProductCount] = useState<any>([])
  const [buyerProductCount, setBuyerProductCount] = useState<any>([])
  const [userTypeCount, setUserTypeCount] = useState<any>([])
  const [stateWiseUserCount, setStateWiseUserCount] = useState<any>([])
  const [planActiveUserCount, setPlanActiveUserCount] = useState<any>([])
  const [allActiveUserCount, setAllActiveUserCount] = useState<any>('')
  const [totalActiveUsers, setTotalActiveUsers] = useState<any>('')
  const [planSubscriberCount, setPlanSubscriberCount] = useState<any>([])
  const [totalSubscriberCount, setTotalSubscriberCount] = useState<any>('')
  const [userCountCurrentMonth, setUserCountCurrentMonth] = useState<any>({})

  const [topStats, setTopStats] = useState<any>({
    totalUsers: 0,
    totalPaidSubscriptions: 0,
    totalFreeSubscriptions: 0,
    totalBuyRequests: 0,
    totalSellRequests: 0
  });
  const [topStatsFilter, setTopStatsFilter] = useState<number>(1);


  useEffect(() => {
    const fetchDashboardData = () => {
      // Only fetch data if the tab is active to reduce server load
      if (document.hidden) return;

      getBuyerProductsWithCount().then((res: any) => {
        setBuyerProductCount(res.data);
      })
      getSellerProductsWithCount().then((res: any) => {
        setSellerProductCount(res.data);
      })
      getUserCountStateWise().then((res: any) => {
        setStateWiseUserCount(res.data);
      })
      getUserTypeCount().then((res: any) => {
        setUserTypeCount(res.data);
      })
      getCurrentMonthCount().then((res: any) => {
        setUserCountCurrentMonth(res.data);
        setTotalActiveUsers(res.data.totalActiveUsers);
      })
      PlanActiveUserCount().then((res: any) => {
        setAllActiveUserCount(res.totalActiveUserCount)
        setPlanActiveUserCount(res.data);
      })

      // Removed static fetch to replace with dynamic one
      PlanSubscriberCount().then((res: any) => {
        setTotalSubscriberCount(res.totalSubscriberCount)
        setPlanSubscriberCount(res.data);
      })
    };

    // Initial fetch
    fetchDashboardData();

    // Auto-refresh every 60 seconds
    const intervalId = setInterval(fetchDashboardData, 60000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [])



  const formatCompact = (num: number) => {
    return Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short", maximumFractionDigits: 1 }).format(num);
  }

  const formatDate = (date: Date) => {
    const d = new Date(date)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    const year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [day, month, year].join('/')
  }

  useEffect(() => {
    let startDate = new Date()
    let endDate = new Date()

    switch (topStatsFilter) {
      case 1: // Today
        break;
      case 2: // Week
        startDate.setDate(new Date().getDate() - 7)
        break;
      case 3: // Month
        startDate.setMonth(new Date().getMonth() - 1)
        break;
      case 4: // Year
        startDate.setFullYear(new Date().getFullYear() - 1)
        break;
      case 6: // Lifetime
        startDate = new Date(2020, 0, 1)
        break;
    }

    const custom_date = topStatsFilter !== 6 ? `${formatDate(startDate)} - ${formatDate(endDate)}` : `01/01/2020 - ${formatDate(endDate)}`;

    const fetchTopStats = () => {
      // Only fetch data if the tab is active to reduce server load
      if (document.hidden) return;

      getTopStats(custom_date).then((res: any) => {
        if (res && res.status) {
          setTopStats(res.data);
        }
      });
    };

    // Initial fetch
    fetchTopStats();

    // Auto-refresh every 60 seconds
    const intervalId = setInterval(fetchTopStats, 60000);

    // Cleanup interval on unmount or filter change
    return () => clearInterval(intervalId);
  }, [topStatsFilter])

  const intl = useIntl()




  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}



      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h1 className='text-dark fw-bolder m-0 fs-2'>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</h1>
        <div className="card-toolbar" data-kt-buttons="true">
          <a className={`btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1 ${topStatsFilter === 1 ? 'active' : ''}`} onClick={() => setTopStatsFilter(1)}>Today</a>
          <a className={`btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1 ${topStatsFilter === 2 ? 'active' : ''}`} onClick={() => setTopStatsFilter(2)}>Week</a>
          <a className={`btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1 ${topStatsFilter === 3 ? 'active' : ''}`} onClick={() => setTopStatsFilter(3)}>Month</a>
          <a className={`btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1 ${topStatsFilter === 4 ? 'active' : ''}`} onClick={() => setTopStatsFilter(4)}>Year</a>
          <a className={`btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1 ${topStatsFilter === 6 ? 'active' : ''}`} onClick={() => setTopStatsFilter(6)}>Lifetime</a>
        </div>
      </div>
      <div className='row gy-5 gx-xxl-8 gx-md-5 gx-sm-3 mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col' style={{ flex: '1 1 0', minWidth: '150px' }}>
          <div className='card card-flush h-md-100' style={{ backgroundColor: '#e1f5fe' }}>
            <div className='card-body d-flex flex-column justify-content-between p-6'>
              <div className='d-flex align-items-center mb-4'>
                <i className='bi bi-person-circle fs-1 me-3' style={{ color: '#0288d1' }}></i>
                <span className='text-dark-300 fw-semibold fs-5'>Total Users</span>
              </div>
              <span className='fs-2hx fw-bold text-dark-700'>{formatCompact(Number(topStats.totalUsers))}</span>
            </div>
          </div>
        </div>
        <div className='col' style={{ flex: '1 1 0', minWidth: '150px' }}>
          <div className='card card-flush h-md-100' style={{ backgroundColor: '#e8f5e9' }}>
            <div className='card-body d-flex flex-column justify-content-between p-6'>
              <div className='d-flex align-items-center mb-4'>
                <i className='bi bi-person-check fs-1 me-3' style={{ color: '#388e3c' }}></i>
                <span className='text-dark-300 fw-semibold fs-5'>Paid Subscribers</span>
              </div>
              <span className='fs-2hx fw-bold text-dark-700'>{formatCompact(Number(topStats.totalPaidSubscriptions || 0))}</span>
            </div>
          </div>
        </div>
        <div className='col' style={{ flex: '1 1 0', minWidth: '150px' }}>
          <div className='card card-flush h-md-100' style={{ backgroundColor: '#f3e5f5' }}>
            <div className='card-body d-flex flex-column justify-content-between p-6'>
              <div className='d-flex align-items-center mb-4'>
                <i className='bi bi-person fs-1 me-3' style={{ color: '#7b1fa2' }}></i>
                <span className='text-dark-300 fw-semibold fs-5'>Free Subscribers</span>
              </div>
              <span className='fs-2hx fw-bold text-dark-700'>{formatCompact(Number(topStats.totalFreeSubscriptions || 0))}</span>
            </div>
          </div>
        </div>
        <div className='col' style={{ flex: '1 1 0', minWidth: '150px' }}>
          <div className='card card-flush h-md-100' style={{ backgroundColor: '#fff3e0' }}>
            <div className='card-body d-flex flex-column justify-content-between p-6'>
              <div className='d-flex align-items-center mb-4'>
                <i className='bi bi-cart-plus fs-1 me-3' style={{ color: '#f57c00' }}></i>
                <span className='text-dark-300 fw-semibold fs-5'>Buy Requests</span>
              </div>
              <span className='fs-2hx fw-bold text-dark-700'>{formatCompact(Number(topStats.totalBuyRequests))}</span>
            </div>
          </div>
        </div>
        <div className='col' style={{ flex: '1 1 0', minWidth: '150px' }}>
          <div className='card card-flush h-md-100' style={{ backgroundColor: '#fbe9e7' }}>
            <div className='card-body d-flex flex-column justify-content-between p-6'>
              <div className='d-flex align-items-center mb-4'>
                <i className='bi bi-tags fs-1 me-3' style={{ color: '#d84315' }}></i>
                <span className='text-dark-300 fw-semibold fs-5'>Sell Requests</span>
              </div>
              <span className='fs-2hx fw-bold text-dark-700'>{formatCompact(Number(topStats.totalSellRequests))}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='row gy-5 gx-xxl-8 gx-md-5 gx-sm-3'>
        <div className='col-12'>
          <PaymentReceiveGraph className='card-xxl-stretch mb-5 mb-xl-8' totalActiveUsers={totalActiveUsers} />
        </div>
      </div>

      <div className='row gy-5 gx-xxl-8 gx-md-5 gx-sm-3'>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <MixedWidget userData={userTypeCount} />
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <ListsWidget className='card-xl-stretch mb-xl-8' title="User Plan (Today)" subTitle={`${allActiveUserCount} Plans activated today`} tasks={planActiveUserCount} />
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <ListsWidget className='card-xl-stretch mb-xl-8' title="User Plan (All-Time)" subTitle={`${totalSubscriberCount} Total Subscriptions`} tasks={planSubscriberCount} />
        </div>
      </div>

      <div className='row gy-5 mt-5 gx-xxl-8 gx-md-5 gx-sm-3'>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <ListsWidgetRequest className='card-xl-stretch mb-xl-8' title="Buyer Requirements" subTitle={`${buyerProductCount.length} Request`} tasks={buyerProductCount} />
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <ListsWidgetRequest className='card-xl-stretch mb-xl-8' title="Seller Requirements" subTitle={`${sellerProductCount.length} Request`} tasks={sellerProductCount} />
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12'>
          <CardsWidget
            className='h-md-50 mb-5 mb-xl-10'
            description='Request this month'
            requestCount={userCountCurrentMonth.requestCount}
            pendingCount={userCountCurrentMonth.pendingCount}
            color='#FFFF'
            img={toAbsoluteUrl('media/patterns/vector-1.png')}
          />
          <CardsWidgetUser
            className='h-md-50 mb-5 mb-xl-10'
            description='New Users this month'
            users={userCountCurrentMonth}
            labelColor='dark'
            textColor='gray-300'
          />
        </div>
      </div>
    </>
  )


}

export { DashboardContent }

const DashboardWrapper = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <DashboardContent />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { DashboardWrapper }
